import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import AppContent from '../../../_Shared/Layout/AppContent';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700
    }
});

class Settings extends React.Component {

    constructor(props) {
        super(props);
    }

    handleInputChange = (name, value) => {
        this.props.onEditSettings(name, value);
    }

    render() {
        const { query } = this.props;

        return (<AppContent>
                    <Grid container spacing={24}>
                        <Grid container item xs={5}>
                            <Grid item lg={12} xl={12}>
                                <TextField autoFocus value={query.settings.name} onChange={e => this.handleInputChange('name', e.target.value)} 
                                    id="name" name="name" label="Name" type="text" fullWidth />
                            </Grid>
                        </Grid>
                        <Grid container item xs={7}></Grid>                        
                    </Grid>
                </AppContent>)
    }
}

Settings.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Settings);


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/QueryEditors/DataJoinTabs/Settings.js